<template>
    <transition name="slide-fade" >
        <div class="uk-padding uk-background-muted">
            <h1 class="uk-heading-line uk-text-center"><span>Testimonials</span></h1>
            <div class="uk-container uk-container-large">
                <div class="uk-child-width-1-3@l timer" uk-grid="masonry: true;">
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Client in the health sector  with annual revenues exceeding $100 million. Has been in
                                            existence for over 15 years, but had never received a clean audit.
                                        </h5>
                                        <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    We took over as interim CFO for the organization; reviewed and updated
                                    financial policies and procedures; trained staff; managed implementation of enhanced controls;
                                    provided leadership to the finance team; documented approach to the adoption of new IFRS accounting
                                    standards; assisted with the recruitment of a permanent CFO; and worked with staff throughout the
                                    audit process.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    Client received a clean audit for the first time in their history. The fiscal year closed with the
                                    highest recorded revenue for a 12-month period, and the highest recorded closing cash balance.
                                    Following the preparation of a business case using the UK Treasury’s 5-case model <span class="uk-text-muted">(prepared by FINCOR)</span>, client was able to
                                    finance the acquisition of new building facilities, and is presently working on the expansion of their
                                    service offerings.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Client in the technology sector with annual revenue of over $1.5 million. Has been in
                                            existence for almost 20 years; however, due to the unexpected resignation of key finance staff,
                                            management was unable to get key financial information on the business due to reporting and
                                            reconciliation being several months behind.
                                        </h5>

                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    We provided an ACCA qualified staff to take over the financial
                                    management of the business on an outsourced basis. We quickly got accounts reconciled, made
                                    necessary corrections, and brought the reporting standard up to date.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    Client receives detailed reports monthly within 15 days of month end; was able to reduce the
                                    cost of accounting services by over 35%; satisfied the reporting requirements of external stakeholders;
                                    and no longer has to worry about the performance of this area of business operations.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Non-profit organization with annual revenues circa $1 million. Client had no financial
                                            record system, had difficulty in producing reports to key stakeholders, and was unable to meet audit
                                            standards or requirements.
                                        </h5>

                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    We took over as accountants for the organization and fully set up the
                                    accounting records and system to improve reporting and accountability. As an independent
                                    organization, we assisted in improving the confidence of donor organizations to support the entity; we
                                    prepared periodic and annual reports for managing committees and grant organizations; and assisted
                                    the organization through its first audit.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    The organization’s records are now maintained and reported on independently, and
                                    management and the Executive Committee now receive timely and accurate information on the
                                    organization’s activities, financial position and financial results. Client is having a rebound in public and
                                    donor confidence, and is expected to have a clean audit for the most recently concluded financial year.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Regulatory Agency with annual budget of over $10 million, agency carried out critical
                                            function but lacked an accountability framework or an organizational plan linking resource intervention
                                            to operational and policy objectives.
                                        </h5>
                                        <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    We worked with management to develop a 5-year strategic plan which
                                    outlined the core focus areas for the organization, the specific resources that will be deployed, and how
                                    success will be measured as the plan progressed.
                                    <br><br>
                                    We also prepared staff performance agreements for over 80 employees which linked their annual
                                    performance and targets with those outlined in the Strategic Plan.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    The Board, and Cabinet, approved the strategic plan, published it on their website and uses it as a tool to
                                    guide the activities of the organization. With the performance agreements we developed, the
                                    organization is now able to do meaningful performance assessments while holding staff accountable for
                                    specific targets. Success for staff is automatically linked to success for the organization.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Client in the culture and arts industry, with an annual spend exceeding $1 million. Has
                                            been in existence for over 25 years, but had never received a clean audit.
                                        </h5>
                                        <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    Fincor took on the full financial management of the organization on an
                                    outsourced basis. We reviewed the client’s internal control; created new policies, updated existing ones;
                                    cleaned up the accounting records; prepared a comprehensive fixed asset register; and prepared lead
                                    schedules and other supporting documentation for each asset and liability account.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    Client achieved a clean audit opinion (unqualified) after the first year of us taking over. They
                                    were also able to reduce their cost for accounting and administrative services by 25%. We continue to
                                    manage this client and they continue to maintain their clean audit status.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Public sector client with asset base of over $300 million across all three Islands. Client
                                            was struggling to prove asset existence and value in order to achieve a clean audit opinion.
                                        </h5>
                                        <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    FINCOR carried out a comprehensive project to identify, record and tag
                                    over 35,000 assets across all three Islands. Asset details were uploaded to an online fixed asset
                                    management software enabling drastic reduction in time required to do physical counts. Client was able
                                    to have qualification point removed, and now has a robust asset management programme in place.
                                </p>
                            </div>
                            <!--<div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    Client achieved a clean audit opinion (unqualified) after the first year of us taking over. They
                                    were also able to reduce their cost for accounting and administrative services by 25%. We continue to
                                    manage this client and they continue to maintain their clean audit status.
                                </p>
                            </div>-->
                        </div>
                    </div>
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Over 12 public sector agencies who do outstanding work each year, but lack the time,
                                            resources and capacity to tell their stories and be accountable to the public through Annual Reports.
                                        </h5>
                                        <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    Each year, we are entrusted by Ministries, Portfolios, Offices, Statutory
                                    Authorities and Government Companies to provide full Annual Reports to the public, outlining their
                                    achievements for the year and the interventions made to fulfill the Government’s policy priorities.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    Our clients enjoy professionally prepared comprehensive documents which showcase the work
                                    of their agencies and provide accountability to the public. Documents meet legal requirements under
                                    the Public Management and Finance Law, and are prepared within the statutory deadline. This allows
                                    our clients to shine, and informs the public on how funds are being spent towards progressing country-
                                    wide objectives.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="uk-card ">
                        <div class="uk-card uk-card-default uk-width-1-1@m">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            A real estate developer with a multimillion-dollar portfolio of properties under
                                            development. Company transacts through acquisition development and sale of properties as well as the
                                            rental of high-end condominiums. Volume of work requires a qualified accountant, but not someone on
                                            a full-time basis.
                                        </h5>

                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    Developer outsourced the financial recording and reporting for the
                                    company’s activities to FINCOR. We maintain all financial records, reconcile accounts, and provide up-to-
                                    date reporting that meets reporting requirements for the General Registry and other stakeholders.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    Client’s records are maintained on our secured cloud platform by our qualified and licensed
                                    accounting team, resulting in the Client spending less than a quarter of the cost compared to hiring an
                                    in-house employee.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="uk-card " >
                        <div class="uk-card uk-card-default uk-width-1-1@m" style="border: 1px solid rgb(197,179,88) !important;">
                            <div class="uk-card-header">
                                <div class="uk-grid-small uk-flex-middle" uk-grid>
                                    <div class="uk-width-auto@s">
                                        <img class="uk-border-circle" width="100" height="100" src="../../public/fincor_lion.png">
                                    </div>
                                    <div class="uk-width-expand@s">
                                        <h5 class=" uk-margin-remove-bottom" style="color: #333 !important;">
                                            Client in the restaurant industry in business for almost 20 years, with annual revenue
                                            of over $1 million. The Client’s financial institution required an enhanced reporting regime with
                                            financials prepared by a qualified accountant. Client had no formal accounting system in place and
                                            mainly ran business with information from point-of-sale system.
                                        </h5>

                                    </div>
                                </div>
                            </div>
                            <div class="uk-card-body " style="margin-top: -15px !important; margin-bottom: -15px !important;" >
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">How FINCOR was able to help?</h5>
                                <p>
                                    FINCOR took over as the accountants for the business on an outsourced
                                    basis. We put in place a robust recording and reporting framework that met the requirements of the
                                    financial institution, and provided management with key insights into the business to enable informed
                                    decision making and growth.
                                </p>
                            </div>
                            <div class="uk-card-footer">
                                <h5 class="uk-heading-bullet specHeading uk-text-bold" style="color: rgb(197,179,88) !important;">Outcome</h5>
                                <p>
                                    Client was able to focus on growing the business; was able to, fully pay off debt, and continues to work with
                                    us as trusted partners to account for, and advise on, multiple aspects of operations.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "clientList",
      metaInfo: {
        title: 'Testimonials',
        meta: [{
          content: 'Our clients are our greatest assets. Here we cataloged some of their stories and how we were able to help them. '
        }]
      }
    }
</script>

<style scoped>
    .timer > .uk-card > div{
        border: 1px solid rgb(197,179,88) !important;
        border-radius: 5px;
    }
</style>